import { api } from "@/lib/api";

const KEY = "velluto_src";
let config = null;

export function captureSource() {
  const p = new URLSearchParams(window.location.search);
  const source = p.get("utm_source") || p.get("src") || "";
  if (!source || localStorage.getItem(KEY)) return;
  localStorage.setItem(KEY, JSON.stringify({
    source: source.slice(0, 80), medium: (p.get("utm_medium") || "").slice(0, 80),
    campaign: (p.get("utm_campaign") || "").slice(0, 120), landing: window.location.pathname.slice(0, 200),
  }));
}

export function takeSource() {
  try { return JSON.parse(localStorage.getItem(KEY)) || undefined; } catch { return undefined; }
}

export const clearSource = () => localStorage.removeItem(KEY);

export function injectHtml(html, target = document.body) {
  if (!html) return;
  const frag = document.createRange().createContextualFragment(html);
  target.appendChild(frag);
}

export async function loadMarketing() {
  if (config) return config;
  try { config = (await api.get("/marketing/config")).data; } catch { config = {}; }
  injectHtml(config.head_code, document.head);
  return config;
}

export async function fireSignupConversion() {
  const c = await loadMarketing();
  injectHtml(c.signup_code);
  clearSource();
}
